// OrderDetails.tsx
import { HttpTypes } from "@medusajs/types";
import Link from "next/link";
import { bagelFatOne } from "@/utilities/fontImport";
import { cn } from "@/utilities/ui";

import { getOrderStatus } from "./orderStatus";

export const OrdersListDetails = ({
  orders,
}: {
  orders: HttpTypes.StoreOrder[];
}) => {
  if (!orders || orders.length === 0) {
    return (
      <div className="rounded-[2.5rem] border border-white bg-white shadow-xl shadow-light-pink/40 p-10 text-center">
        <h2 className={cn("text-2xl font-bold mb-2 text-primary", bagelFatOne.className)}>
          Mes commandes
        </h2>
        <p className="font-semibold text-primary/55">Vous n&apos;avez pas encore de commande.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className={cn("text-2xl font-bold mb-1 text-primary", bagelFatOne.className)}>
        Mes commandes
      </h2>
      <p className="font-semibold text-primary/55 text-sm mb-6">
        Retrouvez l&apos;historique et le suivi de vos commandes.
      </p>

      <div className="flex flex-col gap-3.5">
        {orders.map((order) => {
          const status = getOrderStatus(order);

          return (
            <div
              key={order.id}
              className="flex flex-wrap items-center justify-between gap-4 rounded-3xl border border-light-pink bg-white p-5"
            >
              <div className="flex items-center gap-4">
                <span className="rounded-full bg-pink-200 px-3.5 py-1.5 text-sm font-extrabold text-primary">
                  #{order.display_id}
                </span>
                <span className="text-sm font-semibold text-primary/60">
                  {new Date(order.created_at).toLocaleDateString("fr-FR")}
                </span>
              </div>

              <span className={cn("rounded-full px-3.5 py-1.5 text-xs font-extrabold", status.className)}>
                {status.label}
              </span>

              <div className="flex items-center gap-5">
                <span className="text-lg font-extrabold text-primary">{order?.total}€</span>
                <Link
                  href={`/account/orders/${order.id}`}
                  className="rounded-full bg-bg-orange-to-purple px-5 py-2.5 text-sm font-extrabold text-white shadow-md transition-opacity hover:opacity-90"
                >
                  Voir
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
